package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Turkmenistan Flag (16x12dp)
 *
 * - ISO Alpha-2: TM
 * - ISO Alpha-3: TKM
 * - ISO Numeric: 795
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Turkmenistan: ImageVector by lazy {
    ImageVector.Builder(
        name = "Turkmenistan:TM:TKM:795:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF29C470)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFC51918))) {
                moveTo(1f, -0.161f)
                horizontalLineToRelative(5f)
                verticalLineToRelative(13.161f)
                horizontalLineToRelative(-5f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(1f, -0.161f)
                horizontalLineToRelative(5f)
                verticalLineToRelative(13.161f)
                horizontalLineToRelative(-5f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(1.298f, 0.453f)
                lineTo(1.025f, 0.804f)
                lineTo(1f, 0.779f)
                lineTo(1.265f, 0.439f)
                verticalLineTo(0.371f)
                lineTo(1.266f, 0.364f)
                lineTo(1.297f, 0.269f)
                lineTo(1.278f, 0.236f)
                lineTo(1.122f, 0.393f)
                lineTo(1.423f, -0.076f)
                verticalLineTo(0.084f)
                lineTo(1.481f, 0.136f)
                lineTo(1.619f, -0.105f)
                lineTo(1.48f, -0.338f)
                lineTo(1.38f, -0.261f)
                lineTo(1.421f, -0.18f)
                lineTo(1.393f, -0.16f)
                lineTo(1.167f, -0.538f)
                lineTo(1.311f, -0.439f)
                lineTo(1.336f, -0.476f)
                lineTo(1.198f, -0.616f)
                lineTo(1.259f, -0.684f)
                lineTo(1.058f, -0.977f)
                lineTo(1.084f, -1f)
                lineTo(1.303f, -0.68f)
                lineTo(1.246f, -0.618f)
                lineTo(1.381f, -0.481f)
                lineTo(1.319f, -0.391f)
                lineTo(1.278f, -0.419f)
                lineTo(1.356f, -0.287f)
                lineTo(1.489f, -0.389f)
                lineTo(1.658f, -0.106f)
                lineTo(1.488f, 0.19f)
                lineTo(1.39f, 0.102f)
                verticalLineTo(0.038f)
                lineTo(1.291f, 0.191f)
                lineTo(1.333f, 0.265f)
                lineTo(1.298f, 0.374f)
                verticalLineTo(0.453f)
                close()
                moveTo(1.025f, 3.315f)
                lineTo(1.298f, 2.964f)
                verticalLineTo(2.885f)
                lineTo(1.333f, 2.776f)
                lineTo(1.291f, 2.703f)
                lineTo(1.39f, 2.549f)
                verticalLineTo(2.613f)
                lineTo(1.488f, 2.702f)
                lineTo(1.658f, 2.406f)
                lineTo(1.489f, 2.122f)
                lineTo(1.356f, 2.224f)
                lineTo(1.278f, 2.092f)
                lineTo(1.319f, 2.121f)
                lineTo(1.381f, 2.031f)
                lineTo(1.246f, 1.894f)
                lineTo(1.303f, 1.831f)
                lineTo(1.084f, 1.511f)
                lineTo(1.058f, 1.534f)
                lineTo(1.259f, 1.828f)
                lineTo(1.198f, 1.895f)
                lineTo(1.336f, 2.035f)
                lineTo(1.311f, 2.072f)
                lineTo(1.167f, 1.974f)
                lineTo(1.393f, 2.351f)
                lineTo(1.421f, 2.332f)
                lineTo(1.38f, 2.25f)
                lineTo(1.48f, 2.174f)
                lineTo(1.619f, 2.406f)
                lineTo(1.481f, 2.647f)
                lineTo(1.423f, 2.595f)
                verticalLineTo(2.435f)
                lineTo(1.122f, 2.904f)
                lineTo(1.278f, 2.748f)
                lineTo(1.297f, 2.781f)
                lineTo(1.266f, 2.876f)
                lineTo(1.265f, 2.882f)
                verticalLineTo(2.95f)
                lineTo(1f, 3.291f)
                lineTo(1.025f, 3.315f)
                close()
                moveTo(1.298f, 5.254f)
                lineTo(1.025f, 5.605f)
                lineTo(1f, 5.581f)
                lineTo(1.265f, 5.24f)
                verticalLineTo(5.172f)
                lineTo(1.266f, 5.166f)
                lineTo(1.297f, 5.071f)
                lineTo(1.278f, 5.038f)
                lineTo(1.122f, 5.194f)
                lineTo(1.423f, 4.725f)
                verticalLineTo(4.885f)
                lineTo(1.481f, 4.937f)
                lineTo(1.619f, 4.696f)
                lineTo(1.48f, 4.463f)
                lineTo(1.38f, 4.54f)
                lineTo(1.421f, 4.622f)
                lineTo(1.393f, 4.641f)
                lineTo(1.167f, 4.264f)
                lineTo(1.311f, 4.362f)
                lineTo(1.336f, 4.325f)
                lineTo(1.198f, 4.185f)
                lineTo(1.259f, 4.118f)
                lineTo(1.058f, 3.824f)
                lineTo(1.084f, 3.801f)
                lineTo(1.303f, 4.121f)
                lineTo(1.246f, 4.184f)
                lineTo(1.381f, 4.321f)
                lineTo(1.319f, 4.411f)
                lineTo(1.278f, 4.382f)
                lineTo(1.356f, 4.514f)
                lineTo(1.489f, 4.412f)
                lineTo(1.658f, 4.695f)
                lineTo(1.488f, 4.992f)
                lineTo(1.39f, 4.903f)
                verticalLineTo(4.839f)
                lineTo(1.291f, 4.993f)
                lineTo(1.333f, 5.066f)
                lineTo(1.298f, 5.175f)
                verticalLineTo(5.254f)
                close()
                moveTo(1.025f, 7.932f)
                lineTo(1.298f, 7.581f)
                verticalLineTo(7.502f)
                lineTo(1.333f, 7.393f)
                lineTo(1.291f, 7.32f)
                lineTo(1.39f, 7.166f)
                verticalLineTo(7.23f)
                lineTo(1.488f, 7.318f)
                lineTo(1.658f, 7.022f)
                lineTo(1.489f, 6.739f)
                lineTo(1.356f, 6.841f)
                lineTo(1.278f, 6.709f)
                lineTo(1.319f, 6.737f)
                lineTo(1.381f, 6.648f)
                lineTo(1.246f, 6.511f)
                lineTo(1.303f, 6.448f)
                lineTo(1.084f, 6.128f)
                lineTo(1.058f, 6.151f)
                lineTo(1.259f, 6.445f)
                lineTo(1.198f, 6.512f)
                lineTo(1.336f, 6.652f)
                lineTo(1.311f, 6.689f)
                lineTo(1.167f, 6.59f)
                lineTo(1.393f, 6.968f)
                lineTo(1.421f, 6.949f)
                lineTo(1.38f, 6.867f)
                lineTo(1.48f, 6.79f)
                lineTo(1.619f, 7.023f)
                lineTo(1.481f, 7.264f)
                lineTo(1.423f, 7.212f)
                verticalLineTo(7.052f)
                lineTo(1.122f, 7.521f)
                lineTo(1.278f, 7.364f)
                lineTo(1.297f, 7.397f)
                lineTo(1.266f, 7.492f)
                lineTo(1.265f, 7.499f)
                verticalLineTo(7.567f)
                lineTo(1f, 7.907f)
                lineTo(1.025f, 7.932f)
                close()
                moveTo(1.025f, 10f)
                lineTo(1.298f, 9.649f)
                verticalLineTo(9.57f)
                lineTo(1.333f, 9.461f)
                lineTo(1.291f, 9.388f)
                lineTo(1.39f, 9.234f)
                verticalLineTo(9.298f)
                lineTo(1.488f, 9.387f)
                lineTo(1.658f, 9.09f)
                lineTo(1.489f, 8.807f)
                lineTo(1.356f, 8.909f)
                lineTo(1.278f, 8.777f)
                lineTo(1.319f, 8.806f)
                lineTo(1.381f, 8.716f)
                lineTo(1.246f, 8.579f)
                lineTo(1.303f, 8.516f)
                lineTo(1.084f, 8.196f)
                lineTo(1.058f, 8.219f)
                lineTo(1.259f, 8.513f)
                lineTo(1.198f, 8.58f)
                lineTo(1.336f, 8.72f)
                lineTo(1.311f, 8.757f)
                lineTo(1.167f, 8.659f)
                lineTo(1.393f, 9.036f)
                lineTo(1.421f, 9.017f)
                lineTo(1.38f, 8.935f)
                lineTo(1.48f, 8.859f)
                lineTo(1.619f, 9.091f)
                lineTo(1.481f, 9.332f)
                lineTo(1.423f, 9.28f)
                verticalLineTo(9.12f)
                lineTo(1.122f, 9.589f)
                lineTo(1.278f, 9.433f)
                lineTo(1.297f, 9.466f)
                lineTo(1.266f, 9.561f)
                lineTo(1.265f, 9.567f)
                verticalLineTo(9.635f)
                lineTo(1f, 9.976f)
                lineTo(1.025f, 10f)
                close()
                moveTo(5.975f, 10f)
                lineTo(5.702f, 9.649f)
                verticalLineTo(9.57f)
                lineTo(5.667f, 9.461f)
                lineTo(5.709f, 9.388f)
                lineTo(5.61f, 9.234f)
                verticalLineTo(9.298f)
                lineTo(5.512f, 9.387f)
                lineTo(5.342f, 9.09f)
                lineTo(5.511f, 8.807f)
                lineTo(5.644f, 8.909f)
                lineTo(5.722f, 8.777f)
                lineTo(5.681f, 8.806f)
                lineTo(5.619f, 8.716f)
                lineTo(5.754f, 8.579f)
                lineTo(5.697f, 8.516f)
                lineTo(5.916f, 8.196f)
                lineTo(5.942f, 8.219f)
                lineTo(5.741f, 8.513f)
                lineTo(5.802f, 8.58f)
                lineTo(5.664f, 8.72f)
                lineTo(5.689f, 8.757f)
                lineTo(5.833f, 8.659f)
                lineTo(5.607f, 9.036f)
                lineTo(5.579f, 9.017f)
                lineTo(5.62f, 8.935f)
                lineTo(5.52f, 8.859f)
                lineTo(5.381f, 9.091f)
                lineTo(5.519f, 9.332f)
                lineTo(5.577f, 9.28f)
                verticalLineTo(9.12f)
                lineTo(5.878f, 9.589f)
                lineTo(5.722f, 9.433f)
                lineTo(5.703f, 9.466f)
                lineTo(5.734f, 9.561f)
                lineTo(5.735f, 9.567f)
                verticalLineTo(9.635f)
                lineTo(6f, 9.976f)
                lineTo(5.975f, 10f)
                close()
                moveTo(5.702f, 7.581f)
                lineTo(5.975f, 7.932f)
                lineTo(6f, 7.907f)
                lineTo(5.735f, 7.567f)
                verticalLineTo(7.499f)
                lineTo(5.734f, 7.492f)
                lineTo(5.703f, 7.397f)
                lineTo(5.722f, 7.364f)
                lineTo(5.878f, 7.521f)
                lineTo(5.577f, 7.052f)
                verticalLineTo(7.212f)
                lineTo(5.519f, 7.264f)
                lineTo(5.381f, 7.023f)
                lineTo(5.52f, 6.79f)
                lineTo(5.62f, 6.867f)
                lineTo(5.579f, 6.949f)
                lineTo(5.607f, 6.968f)
                lineTo(5.833f, 6.59f)
                lineTo(5.689f, 6.689f)
                lineTo(5.664f, 6.652f)
                lineTo(5.802f, 6.512f)
                lineTo(5.741f, 6.445f)
                lineTo(5.942f, 6.151f)
                lineTo(5.916f, 6.128f)
                lineTo(5.697f, 6.448f)
                lineTo(5.754f, 6.511f)
                lineTo(5.619f, 6.648f)
                lineTo(5.681f, 6.737f)
                lineTo(5.722f, 6.709f)
                lineTo(5.644f, 6.841f)
                lineTo(5.511f, 6.739f)
                lineTo(5.342f, 7.022f)
                lineTo(5.512f, 7.318f)
                lineTo(5.61f, 7.23f)
                verticalLineTo(7.166f)
                lineTo(5.709f, 7.32f)
                lineTo(5.667f, 7.393f)
                lineTo(5.702f, 7.502f)
                verticalLineTo(7.581f)
                close()
                moveTo(5.975f, 5.605f)
                lineTo(5.702f, 5.254f)
                verticalLineTo(5.175f)
                lineTo(5.667f, 5.066f)
                lineTo(5.709f, 4.993f)
                lineTo(5.61f, 4.839f)
                verticalLineTo(4.903f)
                lineTo(5.512f, 4.992f)
                lineTo(5.342f, 4.695f)
                lineTo(5.511f, 4.412f)
                lineTo(5.644f, 4.514f)
                lineTo(5.722f, 4.382f)
                lineTo(5.681f, 4.411f)
                lineTo(5.619f, 4.321f)
                lineTo(5.754f, 4.184f)
                lineTo(5.697f, 4.121f)
                lineTo(5.916f, 3.801f)
                lineTo(5.942f, 3.824f)
                lineTo(5.741f, 4.118f)
                lineTo(5.802f, 4.185f)
                lineTo(5.664f, 4.325f)
                lineTo(5.689f, 4.362f)
                lineTo(5.833f, 4.264f)
                lineTo(5.607f, 4.641f)
                lineTo(5.579f, 4.622f)
                lineTo(5.62f, 4.54f)
                lineTo(5.52f, 4.463f)
                lineTo(5.381f, 4.696f)
                lineTo(5.519f, 4.937f)
                lineTo(5.577f, 4.885f)
                verticalLineTo(4.725f)
                lineTo(5.878f, 5.194f)
                lineTo(5.722f, 5.038f)
                lineTo(5.703f, 5.071f)
                lineTo(5.734f, 5.166f)
                lineTo(5.735f, 5.172f)
                verticalLineTo(5.24f)
                lineTo(6f, 5.581f)
                lineTo(5.975f, 5.605f)
                close()
                moveTo(5.702f, 2.964f)
                lineTo(5.975f, 3.315f)
                lineTo(6f, 3.291f)
                lineTo(5.735f, 2.95f)
                verticalLineTo(2.882f)
                lineTo(5.734f, 2.876f)
                lineTo(5.703f, 2.781f)
                lineTo(5.722f, 2.748f)
                lineTo(5.878f, 2.904f)
                lineTo(5.577f, 2.435f)
                verticalLineTo(2.595f)
                lineTo(5.519f, 2.647f)
                lineTo(5.381f, 2.406f)
                lineTo(5.52f, 2.174f)
                lineTo(5.62f, 2.25f)
                lineTo(5.579f, 2.332f)
                lineTo(5.607f, 2.351f)
                lineTo(5.833f, 1.974f)
                lineTo(5.689f, 2.072f)
                lineTo(5.664f, 2.035f)
                lineTo(5.802f, 1.895f)
                lineTo(5.741f, 1.828f)
                lineTo(5.942f, 1.534f)
                lineTo(5.916f, 1.511f)
                lineTo(5.697f, 1.831f)
                lineTo(5.754f, 1.894f)
                lineTo(5.619f, 2.031f)
                lineTo(5.681f, 2.121f)
                lineTo(5.722f, 2.092f)
                lineTo(5.644f, 2.224f)
                lineTo(5.511f, 2.122f)
                lineTo(5.342f, 2.406f)
                lineTo(5.512f, 2.702f)
                lineTo(5.61f, 2.613f)
                verticalLineTo(2.549f)
                lineTo(5.709f, 2.703f)
                lineTo(5.667f, 2.776f)
                lineTo(5.702f, 2.885f)
                verticalLineTo(2.964f)
                close()
                moveTo(5.975f, 0.804f)
                lineTo(5.702f, 0.453f)
                verticalLineTo(0.374f)
                lineTo(5.667f, 0.265f)
                lineTo(5.709f, 0.191f)
                lineTo(5.61f, 0.038f)
                verticalLineTo(0.102f)
                lineTo(5.512f, 0.19f)
                lineTo(5.342f, -0.106f)
                lineTo(5.511f, -0.389f)
                lineTo(5.644f, -0.287f)
                lineTo(5.722f, -0.419f)
                lineTo(5.681f, -0.391f)
                lineTo(5.619f, -0.481f)
                lineTo(5.754f, -0.618f)
                lineTo(5.697f, -0.68f)
                lineTo(5.916f, -1f)
                lineTo(5.942f, -0.977f)
                lineTo(5.741f, -0.684f)
                lineTo(5.802f, -0.616f)
                lineTo(5.664f, -0.476f)
                lineTo(5.689f, -0.439f)
                lineTo(5.833f, -0.538f)
                lineTo(5.607f, -0.16f)
                lineTo(5.579f, -0.18f)
                lineTo(5.62f, -0.261f)
                lineTo(5.52f, -0.338f)
                lineTo(5.381f, -0.105f)
                lineTo(5.519f, 0.136f)
                lineTo(5.577f, 0.084f)
                verticalLineTo(-0.076f)
                lineTo(5.878f, 0.393f)
                lineTo(5.722f, 0.236f)
                lineTo(5.703f, 0.269f)
                lineTo(5.734f, 0.364f)
                lineTo(5.735f, 0.371f)
                verticalLineTo(0.439f)
                lineTo(6f, 0.779f)
                lineTo(5.975f, 0.804f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF389F5D)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.653f, 7.282f)
                horizontalLineTo(4.43f)
                verticalLineTo(7.465f)
                horizontalLineTo(4.607f)
                verticalLineTo(7.61f)
                horizontalLineTo(4.819f)
                verticalLineTo(8.084f)
                horizontalLineTo(4.607f)
                verticalLineTo(8.23f)
                horizontalLineTo(4.43f)
                verticalLineTo(8.376f)
                horizontalLineTo(3.674f)
                lineTo(3.465f, 8.562f)
                lineTo(3.255f, 8.376f)
                horizontalLineTo(2.554f)
                verticalLineTo(8.23f)
                horizontalLineTo(2.377f)
                verticalLineTo(8.084f)
                horizontalLineTo(2.2f)
                verticalLineTo(7.61f)
                horizontalLineTo(2.377f)
                verticalLineTo(7.465f)
                horizontalLineTo(2.554f)
                verticalLineTo(7.282f)
                horizontalLineTo(3.276f)
                lineTo(3.465f, 7.115f)
                lineTo(3.653f, 7.282f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(4.43f, 7.282f)
                horizontalLineTo(4.505f)
                verticalLineTo(7.207f)
                horizontalLineTo(4.43f)
                verticalLineTo(7.282f)
                close()
                moveTo(3.653f, 7.282f)
                lineTo(3.603f, 7.338f)
                lineTo(3.625f, 7.357f)
                horizontalLineTo(3.653f)
                verticalLineTo(7.282f)
                close()
                moveTo(4.43f, 7.465f)
                horizontalLineTo(4.355f)
                verticalLineTo(7.54f)
                horizontalLineTo(4.43f)
                verticalLineTo(7.465f)
                close()
                moveTo(4.607f, 7.465f)
                horizontalLineTo(4.682f)
                verticalLineTo(7.39f)
                horizontalLineTo(4.607f)
                verticalLineTo(7.465f)
                close()
                moveTo(4.607f, 7.61f)
                horizontalLineTo(4.532f)
                verticalLineTo(7.685f)
                horizontalLineTo(4.607f)
                verticalLineTo(7.61f)
                close()
                moveTo(4.819f, 7.61f)
                horizontalLineTo(4.894f)
                verticalLineTo(7.535f)
                horizontalLineTo(4.819f)
                verticalLineTo(7.61f)
                close()
                moveTo(4.819f, 8.084f)
                verticalLineTo(8.159f)
                horizontalLineTo(4.894f)
                verticalLineTo(8.084f)
                horizontalLineTo(4.819f)
                close()
                moveTo(4.607f, 8.084f)
                verticalLineTo(8.009f)
                horizontalLineTo(4.532f)
                verticalLineTo(8.084f)
                horizontalLineTo(4.607f)
                close()
                moveTo(4.607f, 8.23f)
                verticalLineTo(8.305f)
                horizontalLineTo(4.682f)
                verticalLineTo(8.23f)
                horizontalLineTo(4.607f)
                close()
                moveTo(4.43f, 8.23f)
                verticalLineTo(8.155f)
                horizontalLineTo(4.355f)
                verticalLineTo(8.23f)
                horizontalLineTo(4.43f)
                close()
                moveTo(4.43f, 8.376f)
                verticalLineTo(8.451f)
                horizontalLineTo(4.505f)
                verticalLineTo(8.376f)
                horizontalLineTo(4.43f)
                close()
                moveTo(3.674f, 8.376f)
                verticalLineTo(8.301f)
                horizontalLineTo(3.645f)
                lineTo(3.624f, 8.32f)
                lineTo(3.674f, 8.376f)
                close()
                moveTo(3.465f, 8.562f)
                lineTo(3.415f, 8.618f)
                lineTo(3.465f, 8.662f)
                lineTo(3.515f, 8.618f)
                lineTo(3.465f, 8.562f)
                close()
                moveTo(3.255f, 8.376f)
                lineTo(3.304f, 8.32f)
                lineTo(3.283f, 8.301f)
                horizontalLineTo(3.255f)
                verticalLineTo(8.376f)
                close()
                moveTo(2.554f, 8.376f)
                horizontalLineTo(2.479f)
                verticalLineTo(8.451f)
                horizontalLineTo(2.554f)
                verticalLineTo(8.376f)
                close()
                moveTo(2.554f, 8.23f)
                horizontalLineTo(2.629f)
                verticalLineTo(8.155f)
                horizontalLineTo(2.554f)
                verticalLineTo(8.23f)
                close()
                moveTo(2.377f, 8.23f)
                horizontalLineTo(2.302f)
                verticalLineTo(8.305f)
                horizontalLineTo(2.377f)
                verticalLineTo(8.23f)
                close()
                moveTo(2.377f, 8.084f)
                horizontalLineTo(2.452f)
                verticalLineTo(8.009f)
                horizontalLineTo(2.377f)
                verticalLineTo(8.084f)
                close()
                moveTo(2.2f, 8.084f)
                horizontalLineTo(2.125f)
                verticalLineTo(8.159f)
                horizontalLineTo(2.2f)
                verticalLineTo(8.084f)
                close()
                moveTo(2.2f, 7.61f)
                verticalLineTo(7.535f)
                horizontalLineTo(2.125f)
                verticalLineTo(7.61f)
                horizontalLineTo(2.2f)
                close()
                moveTo(2.377f, 7.61f)
                verticalLineTo(7.685f)
                horizontalLineTo(2.452f)
                verticalLineTo(7.61f)
                horizontalLineTo(2.377f)
                close()
                moveTo(2.377f, 7.465f)
                verticalLineTo(7.39f)
                horizontalLineTo(2.302f)
                verticalLineTo(7.465f)
                horizontalLineTo(2.377f)
                close()
                moveTo(2.554f, 7.465f)
                verticalLineTo(7.54f)
                horizontalLineTo(2.629f)
                verticalLineTo(7.465f)
                horizontalLineTo(2.554f)
                close()
                moveTo(2.554f, 7.282f)
                verticalLineTo(7.207f)
                horizontalLineTo(2.479f)
                verticalLineTo(7.282f)
                horizontalLineTo(2.554f)
                close()
                moveTo(3.276f, 7.282f)
                verticalLineTo(7.357f)
                horizontalLineTo(3.304f)
                lineTo(3.325f, 7.339f)
                lineTo(3.276f, 7.282f)
                close()
                moveTo(3.465f, 7.115f)
                lineTo(3.515f, 7.059f)
                lineTo(3.465f, 7.015f)
                lineTo(3.415f, 7.059f)
                lineTo(3.465f, 7.115f)
                close()
                moveTo(4.43f, 7.207f)
                horizontalLineTo(3.653f)
                verticalLineTo(7.357f)
                horizontalLineTo(4.43f)
                verticalLineTo(7.207f)
                close()
                moveTo(4.505f, 7.465f)
                verticalLineTo(7.282f)
                horizontalLineTo(4.355f)
                verticalLineTo(7.465f)
                horizontalLineTo(4.505f)
                close()
                moveTo(4.607f, 7.39f)
                horizontalLineTo(4.43f)
                verticalLineTo(7.54f)
                horizontalLineTo(4.607f)
                verticalLineTo(7.39f)
                close()
                moveTo(4.682f, 7.61f)
                verticalLineTo(7.465f)
                horizontalLineTo(4.532f)
                verticalLineTo(7.61f)
                horizontalLineTo(4.682f)
                close()
                moveTo(4.819f, 7.535f)
                horizontalLineTo(4.607f)
                verticalLineTo(7.685f)
                horizontalLineTo(4.819f)
                verticalLineTo(7.535f)
                close()
                moveTo(4.894f, 8.084f)
                verticalLineTo(7.61f)
                horizontalLineTo(4.744f)
                verticalLineTo(8.084f)
                horizontalLineTo(4.894f)
                close()
                moveTo(4.607f, 8.159f)
                horizontalLineTo(4.819f)
                verticalLineTo(8.009f)
                horizontalLineTo(4.607f)
                verticalLineTo(8.159f)
                close()
                moveTo(4.682f, 8.23f)
                verticalLineTo(8.084f)
                horizontalLineTo(4.532f)
                verticalLineTo(8.23f)
                horizontalLineTo(4.682f)
                close()
                moveTo(4.43f, 8.305f)
                horizontalLineTo(4.607f)
                verticalLineTo(8.155f)
                horizontalLineTo(4.43f)
                verticalLineTo(8.305f)
                close()
                moveTo(4.505f, 8.376f)
                verticalLineTo(8.23f)
                horizontalLineTo(4.355f)
                verticalLineTo(8.376f)
                horizontalLineTo(4.505f)
                close()
                moveTo(3.674f, 8.451f)
                horizontalLineTo(4.43f)
                verticalLineTo(8.301f)
                horizontalLineTo(3.674f)
                verticalLineTo(8.451f)
                close()
                moveTo(3.515f, 8.618f)
                lineTo(3.724f, 8.432f)
                lineTo(3.624f, 8.32f)
                lineTo(3.415f, 8.506f)
                lineTo(3.515f, 8.618f)
                close()
                moveTo(3.205f, 8.432f)
                lineTo(3.415f, 8.618f)
                lineTo(3.515f, 8.506f)
                lineTo(3.304f, 8.32f)
                lineTo(3.205f, 8.432f)
                close()
                moveTo(2.554f, 8.451f)
                horizontalLineTo(3.255f)
                verticalLineTo(8.301f)
                horizontalLineTo(2.554f)
                verticalLineTo(8.451f)
                close()
                moveTo(2.479f, 8.23f)
                verticalLineTo(8.376f)
                horizontalLineTo(2.629f)
                verticalLineTo(8.23f)
                horizontalLineTo(2.479f)
                close()
                moveTo(2.377f, 8.305f)
                horizontalLineTo(2.554f)
                verticalLineTo(8.155f)
                horizontalLineTo(2.377f)
                verticalLineTo(8.305f)
                close()
                moveTo(2.302f, 8.084f)
                verticalLineTo(8.23f)
                horizontalLineTo(2.452f)
                verticalLineTo(8.084f)
                horizontalLineTo(2.302f)
                close()
                moveTo(2.2f, 8.159f)
                horizontalLineTo(2.377f)
                verticalLineTo(8.009f)
                horizontalLineTo(2.2f)
                verticalLineTo(8.159f)
                close()
                moveTo(2.125f, 7.61f)
                verticalLineTo(8.084f)
                horizontalLineTo(2.275f)
                verticalLineTo(7.61f)
                horizontalLineTo(2.125f)
                close()
                moveTo(2.377f, 7.535f)
                horizontalLineTo(2.2f)
                verticalLineTo(7.685f)
                horizontalLineTo(2.377f)
                verticalLineTo(7.535f)
                close()
                moveTo(2.302f, 7.465f)
                verticalLineTo(7.61f)
                horizontalLineTo(2.452f)
                verticalLineTo(7.465f)
                horizontalLineTo(2.302f)
                close()
                moveTo(2.554f, 7.39f)
                horizontalLineTo(2.377f)
                verticalLineTo(7.54f)
                horizontalLineTo(2.554f)
                verticalLineTo(7.39f)
                close()
                moveTo(2.479f, 7.282f)
                verticalLineTo(7.465f)
                horizontalLineTo(2.629f)
                verticalLineTo(7.282f)
                horizontalLineTo(2.479f)
                close()
                moveTo(3.276f, 7.207f)
                horizontalLineTo(2.554f)
                verticalLineTo(7.357f)
                horizontalLineTo(3.276f)
                verticalLineTo(7.207f)
                close()
                moveTo(3.325f, 7.339f)
                lineTo(3.515f, 7.171f)
                lineTo(3.415f, 7.059f)
                lineTo(3.226f, 7.226f)
                lineTo(3.325f, 7.339f)
                close()
                moveTo(3.415f, 7.171f)
                lineTo(3.603f, 7.338f)
                lineTo(3.703f, 7.226f)
                lineTo(3.515f, 7.059f)
                lineTo(3.415f, 7.171f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2.658f, 7.704f)
                verticalLineTo(7.382f)
                horizontalLineTo(3.033f)
                lineTo(2.658f, 7.704f)
                close()
                moveTo(4.236f, 7.704f)
                verticalLineTo(7.382f)
                horizontalLineTo(3.861f)
                lineTo(4.236f, 7.704f)
                close()
                moveTo(2.658f, 8.287f)
                verticalLineTo(7.965f)
                lineTo(3.033f, 8.287f)
                horizontalLineTo(2.658f)
                close()
                moveTo(4.236f, 7.965f)
                verticalLineTo(8.287f)
                horizontalLineTo(3.861f)
                lineTo(4.236f, 7.965f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.323f, 7.409f)
                lineTo(3.452f, 7.24f)
                lineTo(3.58f, 7.409f)
                horizontalLineTo(3.323f)
                close()
                moveTo(3.323f, 7.568f)
                lineTo(3.452f, 7.737f)
                lineTo(3.58f, 7.568f)
                horizontalLineTo(3.323f)
                close()
                moveTo(3.452f, 7.969f)
                lineTo(3.323f, 8.139f)
                horizontalLineTo(3.58f)
                lineTo(3.452f, 7.969f)
                close()
                moveTo(3.323f, 8.297f)
                lineTo(3.452f, 8.467f)
                lineTo(3.58f, 8.297f)
                horizontalLineTo(3.323f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFAF0100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.325f, 7.389f)
                verticalLineTo(7.462f)
                horizontalLineTo(3.251f)
                verticalLineTo(7.562f)
                horizontalLineTo(3.325f)
                verticalLineTo(7.635f)
                horizontalLineTo(3.585f)
                verticalLineTo(7.562f)
                horizontalLineTo(3.659f)
                verticalLineTo(7.462f)
                horizontalLineTo(3.585f)
                verticalLineTo(7.389f)
                horizontalLineTo(3.325f)
                close()
                moveTo(3.585f, 8.191f)
                verticalLineTo(8.118f)
                horizontalLineTo(3.325f)
                verticalLineTo(8.191f)
                horizontalLineTo(3.251f)
                verticalLineTo(8.291f)
                horizontalLineTo(3.325f)
                verticalLineTo(8.364f)
                horizontalLineTo(3.585f)
                verticalLineTo(8.291f)
                horizontalLineTo(3.659f)
                verticalLineTo(8.191f)
                horizontalLineTo(3.585f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFAF0100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2.827f, 7.775f)
                lineTo(2.95f, 7.604f)
                lineTo(3.072f, 7.775f)
                horizontalLineTo(2.827f)
                close()
                moveTo(2.827f, 7.934f)
                lineTo(2.95f, 8.104f)
                lineTo(3.072f, 7.934f)
                horizontalLineTo(2.827f)
                close()
                moveTo(3.977f, 7.604f)
                lineTo(3.853f, 7.775f)
                horizontalLineTo(4.099f)
                lineTo(3.977f, 7.604f)
                close()
                moveTo(3.853f, 7.934f)
                lineTo(3.977f, 8.104f)
                lineTo(4.099f, 7.934f)
                horizontalLineTo(3.853f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(2.826f, 7.754f)
                verticalLineTo(7.828f)
                horizontalLineTo(2.755f)
                verticalLineTo(7.93f)
                horizontalLineTo(2.826f)
                verticalLineTo(8.005f)
                horizontalLineTo(3.073f)
                verticalLineTo(7.93f)
                horizontalLineTo(3.144f)
                verticalLineTo(7.828f)
                horizontalLineTo(3.073f)
                verticalLineTo(7.754f)
                horizontalLineTo(2.826f)
                close()
                moveTo(4.1f, 7.828f)
                verticalLineTo(7.754f)
                horizontalLineTo(3.853f)
                verticalLineTo(7.828f)
                horizontalLineTo(3.782f)
                verticalLineTo(7.93f)
                horizontalLineTo(3.853f)
                verticalLineTo(8.005f)
                horizontalLineTo(4.1f)
                verticalLineTo(7.93f)
                horizontalLineTo(4.17f)
                verticalLineTo(7.828f)
                horizontalLineTo(4.1f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(3.109f, 8.625f)
                lineTo(2.223f, 9.125f)
                verticalLineTo(9.953f)
                lineTo(3.109f, 10.472f)
                horizontalLineTo(4.068f)
                lineTo(4.975f, 9.953f)
                verticalLineTo(9.125f)
                lineTo(4.068f, 8.625f)
                horizontalLineTo(3.109f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(2.235f, 9.548f)
                horizontalLineTo(3.616f)
                verticalLineTo(10.459f)
                horizontalLineTo(2.235f)
                verticalLineTo(9.548f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF9E8E7))) {
                moveTo(2.094f, 8.636f)
                horizontalLineToRelative(1.522f)
                verticalLineToRelative(0.911f)
                horizontalLineToRelative(-1.522f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(2.448f, 9.168f)
                lineTo(2.906f, 8.892f)
                verticalLineTo(9.168f)
                horizontalLineTo(2.448f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(5.138f, 8.636f)
                lineToRelative(-1.522f, 0f)
                lineToRelative(-0f, 0.911f)
                lineToRelative(1.522f, 0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF9E8E7))) {
                moveTo(4.678f, 9.168f)
                lineTo(4.22f, 8.892f)
                verticalLineTo(9.168f)
                horizontalLineTo(4.678f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF9E8E7))) {
                moveTo(4.996f, 10.459f)
                lineToRelative(-1.381f, -0f)
                lineToRelative(-0f, -0.911f)
                lineToRelative(1.381f, -0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(4.642f, 9.928f)
                lineTo(4.184f, 10.204f)
                verticalLineTo(9.928f)
                horizontalLineTo(4.642f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFCFCFC))) {
                moveTo(2.448f, 9.871f)
                lineTo(2.906f, 10.147f)
                verticalLineTo(9.871f)
                horizontalLineTo(2.448f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.12f, 9.183f)
            horizontalLineTo(3.35f)
            lineTo(3.581f, 9.11f)
            lineTo(3.811f, 9.183f)
            horizontalLineTo(4.041f)
            verticalLineTo(9.876f)
            horizontalLineTo(3.811f)
            lineTo(3.581f, 9.985f)
            lineTo(3.35f, 9.876f)
            horizontalLineTo(3.12f)
            verticalLineTo(9.183f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC9343F)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.899f, 8.769f)
            horizontalLineTo(4.024f)
            verticalLineTo(8.91f)
            horizontalLineTo(4.075f)
            verticalLineTo(9.01f)
            horizontalLineTo(4.024f)
            verticalLineTo(9.064f)
            horizontalLineTo(3.899f)
            verticalLineTo(8.769f)
            close()
            moveTo(2.644f, 9.206f)
            horizontalLineTo(2.519f)
            verticalLineTo(9.501f)
            horizontalLineTo(2.644f)
            verticalLineTo(9.447f)
            horizontalLineTo(2.695f)
            verticalLineTo(9.347f)
            horizontalLineTo(2.644f)
            verticalLineTo(9.206f)
            close()
            moveTo(2.821f, 9.206f)
            horizontalLineTo(2.696f)
            verticalLineTo(9.501f)
            horizontalLineTo(2.821f)
            verticalLineTo(9.206f)
            close()
            moveTo(2.644f, 9.571f)
            horizontalLineTo(2.519f)
            verticalLineTo(9.866f)
            horizontalLineTo(2.644f)
            verticalLineTo(9.812f)
            horizontalLineTo(2.695f)
            verticalLineTo(9.712f)
            horizontalLineTo(2.644f)
            verticalLineTo(9.571f)
            close()
            moveTo(2.696f, 9.571f)
            horizontalLineTo(2.821f)
            verticalLineTo(9.866f)
            horizontalLineTo(2.696f)
            verticalLineTo(9.571f)
            close()
            moveTo(4.466f, 9.206f)
            horizontalLineTo(4.591f)
            verticalLineTo(9.347f)
            horizontalLineTo(4.642f)
            verticalLineTo(9.447f)
            horizontalLineTo(4.591f)
            verticalLineTo(9.501f)
            horizontalLineTo(4.466f)
            verticalLineTo(9.206f)
            close()
            moveTo(4.768f, 9.206f)
            horizontalLineTo(4.643f)
            verticalLineTo(9.501f)
            horizontalLineTo(4.768f)
            verticalLineTo(9.206f)
            close()
            moveTo(4.591f, 9.571f)
            horizontalLineTo(4.466f)
            verticalLineTo(9.866f)
            horizontalLineTo(4.591f)
            verticalLineTo(9.812f)
            horizontalLineTo(4.642f)
            verticalLineTo(9.712f)
            horizontalLineTo(4.591f)
            verticalLineTo(9.571f)
            close()
            moveTo(4.643f, 9.571f)
            horizontalLineTo(4.768f)
            verticalLineTo(9.866f)
            horizontalLineTo(4.643f)
            verticalLineTo(9.571f)
            close()
            moveTo(4.201f, 8.769f)
            horizontalLineTo(4.076f)
            verticalLineTo(9.064f)
            horizontalLineTo(4.201f)
            verticalLineTo(8.769f)
            close()
            moveTo(3.175f, 8.769f)
            horizontalLineTo(3.05f)
            verticalLineTo(9.064f)
            horizontalLineTo(3.175f)
            verticalLineTo(9.01f)
            horizontalLineTo(3.226f)
            verticalLineTo(8.91f)
            horizontalLineTo(3.175f)
            verticalLineTo(8.769f)
            close()
            moveTo(3.227f, 8.769f)
            horizontalLineTo(3.352f)
            verticalLineTo(9.064f)
            horizontalLineTo(3.227f)
            verticalLineTo(8.769f)
            close()
            moveTo(3.899f, 10.008f)
            horizontalLineTo(4.024f)
            verticalLineTo(10.149f)
            horizontalLineTo(4.075f)
            verticalLineTo(10.25f)
            horizontalLineTo(4.024f)
            verticalLineTo(10.303f)
            horizontalLineTo(3.899f)
            verticalLineTo(10.008f)
            close()
            moveTo(4.201f, 10.008f)
            horizontalLineTo(4.076f)
            verticalLineTo(10.303f)
            horizontalLineTo(4.201f)
            verticalLineTo(10.008f)
            close()
            moveTo(3.175f, 10.008f)
            horizontalLineTo(3.05f)
            verticalLineTo(10.303f)
            horizontalLineTo(3.175f)
            verticalLineTo(10.25f)
            horizontalLineTo(3.226f)
            verticalLineTo(10.149f)
            horizontalLineTo(3.175f)
            verticalLineTo(10.008f)
            close()
            moveTo(3.227f, 10.008f)
            horizontalLineTo(3.352f)
            verticalLineTo(10.303f)
            horizontalLineTo(3.227f)
            verticalLineTo(10.008f)
            close()
        }
        path(
            fill = SolidColor(Color.White),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.513f, 9.333f)
            horizontalLineTo(3.548f)
            verticalLineTo(9.234f)
            horizontalLineTo(3.371f)
            verticalLineTo(9.347f)
            horizontalLineTo(3.225f)
            verticalLineTo(9.51f)
            horizontalLineTo(3.361f)
            verticalLineTo(9.473f)
            horizontalLineTo(3.261f)
            verticalLineTo(9.384f)
            horizontalLineTo(3.381f)
            lineTo(3.562f, 9.54f)
            lineTo(3.381f, 9.697f)
            horizontalLineTo(3.261f)
            verticalLineTo(9.607f)
            horizontalLineTo(3.361f)
            verticalLineTo(9.571f)
            horizontalLineTo(3.225f)
            verticalLineTo(9.733f)
            horizontalLineTo(3.371f)
            verticalLineTo(9.847f)
            horizontalLineTo(3.548f)
            verticalLineTo(9.748f)
            horizontalLineTo(3.513f)
            verticalLineTo(9.81f)
            horizontalLineTo(3.406f)
            verticalLineTo(9.723f)
            lineTo(3.59f, 9.563f)
            lineTo(3.774f, 9.723f)
            verticalLineTo(9.81f)
            horizontalLineTo(3.668f)
            verticalLineTo(9.748f)
            horizontalLineTo(3.633f)
            verticalLineTo(9.847f)
            horizontalLineTo(3.81f)
            verticalLineTo(9.733f)
            horizontalLineTo(3.956f)
            verticalLineTo(9.571f)
            horizontalLineTo(3.82f)
            verticalLineTo(9.607f)
            horizontalLineTo(3.92f)
            verticalLineTo(9.697f)
            horizontalLineTo(3.8f)
            lineTo(3.619f, 9.54f)
            lineTo(3.8f, 9.384f)
            horizontalLineTo(3.92f)
            verticalLineTo(9.473f)
            horizontalLineTo(3.82f)
            verticalLineTo(9.51f)
            horizontalLineTo(3.956f)
            verticalLineTo(9.347f)
            horizontalLineTo(3.81f)
            verticalLineTo(9.234f)
            horizontalLineTo(3.633f)
            verticalLineTo(9.333f)
            horizontalLineTo(3.668f)
            verticalLineTo(9.271f)
            horizontalLineTo(3.774f)
            verticalLineTo(9.358f)
            lineTo(3.59f, 9.518f)
            lineTo(3.406f, 9.358f)
            verticalLineTo(9.271f)
            horizontalLineTo(3.513f)
            verticalLineTo(9.333f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.792f, 2.4f)
            horizontalLineTo(3.169f)
            verticalLineTo(4.4f)
            horizontalLineTo(3.792f)
            verticalLineTo(2.4f)
            close()
            moveTo(2.39f, 2.823f)
            horizontalLineTo(2.779f)
            verticalLineTo(3.9f)
            horizontalLineTo(2.39f)
            verticalLineTo(2.823f)
            close()
            moveTo(4.221f, 2.823f)
            horizontalLineTo(4.61f)
            verticalLineTo(3.9f)
            horizontalLineTo(4.221f)
            verticalLineTo(2.823f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF389F5D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.169f, 2.554f)
            horizontalLineTo(2.779f)
            verticalLineTo(4.092f)
            horizontalLineTo(3.169f)
            verticalLineTo(2.554f)
            close()
            moveTo(2.39f, 2.977f)
            horizontalLineTo(2f)
            verticalLineTo(3.708f)
            horizontalLineTo(2.39f)
            verticalLineTo(2.977f)
            close()
            moveTo(4.61f, 2.977f)
            horizontalLineTo(5f)
            verticalLineTo(3.708f)
            horizontalLineTo(4.61f)
            verticalLineTo(2.977f)
            close()
            moveTo(4.182f, 2.554f)
            horizontalLineTo(3.792f)
            verticalLineTo(4.092f)
            horizontalLineTo(4.182f)
            verticalLineTo(2.554f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE1E5E8)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.091f, 2.746f)
            curveTo(3.091f, 2.81f, 3.039f, 2.862f, 2.974f, 2.862f)
            curveTo(2.909f, 2.862f, 2.857f, 2.81f, 2.857f, 2.746f)
            curveTo(2.857f, 2.682f, 2.909f, 2.631f, 2.974f, 2.631f)
            curveTo(3.039f, 2.631f, 3.091f, 2.682f, 3.091f, 2.746f)
            close()
            moveTo(2.312f, 3.131f)
            curveTo(2.312f, 3.195f, 2.259f, 3.246f, 2.195f, 3.246f)
            curveTo(2.13f, 3.246f, 2.078f, 3.195f, 2.078f, 3.131f)
            curveTo(2.078f, 3.067f, 2.13f, 3.015f, 2.195f, 3.015f)
            curveTo(2.259f, 3.015f, 2.312f, 3.067f, 2.312f, 3.131f)
            close()
            moveTo(2.312f, 3.554f)
            curveTo(2.312f, 3.618f, 2.259f, 3.669f, 2.195f, 3.669f)
            curveTo(2.13f, 3.669f, 2.078f, 3.618f, 2.078f, 3.554f)
            curveTo(2.078f, 3.49f, 2.13f, 3.438f, 2.195f, 3.438f)
            curveTo(2.259f, 3.438f, 2.312f, 3.49f, 2.312f, 3.554f)
            close()
            moveTo(2.974f, 4.015f)
            curveTo(3.039f, 4.015f, 3.091f, 3.964f, 3.091f, 3.9f)
            curveTo(3.091f, 3.836f, 3.039f, 3.785f, 2.974f, 3.785f)
            curveTo(2.909f, 3.785f, 2.857f, 3.836f, 2.857f, 3.9f)
            curveTo(2.857f, 3.964f, 2.909f, 4.015f, 2.974f, 4.015f)
            close()
            moveTo(4.805f, 3.246f)
            curveTo(4.87f, 3.246f, 4.922f, 3.195f, 4.922f, 3.131f)
            curveTo(4.922f, 3.067f, 4.87f, 3.015f, 4.805f, 3.015f)
            curveTo(4.741f, 3.015f, 4.688f, 3.067f, 4.688f, 3.131f)
            curveTo(4.688f, 3.195f, 4.741f, 3.246f, 4.805f, 3.246f)
            close()
            moveTo(4.922f, 3.554f)
            curveTo(4.922f, 3.618f, 4.87f, 3.669f, 4.805f, 3.669f)
            curveTo(4.741f, 3.669f, 4.688f, 3.618f, 4.688f, 3.554f)
            curveTo(4.688f, 3.49f, 4.741f, 3.438f, 4.805f, 3.438f)
            curveTo(4.87f, 3.438f, 4.922f, 3.49f, 4.922f, 3.554f)
            close()
            moveTo(3.987f, 4.015f)
            curveTo(4.052f, 4.015f, 4.104f, 3.964f, 4.104f, 3.9f)
            curveTo(4.104f, 3.836f, 4.052f, 3.785f, 3.987f, 3.785f)
            curveTo(3.922f, 3.785f, 3.87f, 3.836f, 3.87f, 3.9f)
            curveTo(3.87f, 3.964f, 3.922f, 4.015f, 3.987f, 4.015f)
            close()
            moveTo(4.104f, 2.746f)
            curveTo(4.104f, 2.81f, 4.052f, 2.862f, 3.987f, 2.862f)
            curveTo(3.922f, 2.862f, 3.87f, 2.81f, 3.87f, 2.746f)
            curveTo(3.87f, 2.682f, 3.922f, 2.631f, 3.987f, 2.631f)
            curveTo(4.052f, 2.631f, 4.104f, 2.682f, 4.104f, 2.746f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.597f, 2.592f)
            curveTo(3.597f, 2.656f, 3.545f, 2.708f, 3.481f, 2.708f)
            curveTo(3.416f, 2.708f, 3.364f, 2.656f, 3.364f, 2.592f)
            curveTo(3.364f, 2.529f, 3.416f, 2.477f, 3.481f, 2.477f)
            curveTo(3.545f, 2.477f, 3.597f, 2.529f, 3.597f, 2.592f)
            close()
            moveTo(2.701f, 3.015f)
            curveTo(2.701f, 3.079f, 2.649f, 3.131f, 2.584f, 3.131f)
            curveTo(2.52f, 3.131f, 2.468f, 3.079f, 2.468f, 3.015f)
            curveTo(2.468f, 2.952f, 2.52f, 2.9f, 2.584f, 2.9f)
            curveTo(2.649f, 2.9f, 2.701f, 2.952f, 2.701f, 3.015f)
            close()
            moveTo(3.481f, 4.362f)
            curveTo(3.545f, 4.362f, 3.597f, 4.31f, 3.597f, 4.246f)
            curveTo(3.597f, 4.182f, 3.545f, 4.131f, 3.481f, 4.131f)
            curveTo(3.416f, 4.131f, 3.364f, 4.182f, 3.364f, 4.246f)
            curveTo(3.364f, 4.31f, 3.416f, 4.362f, 3.481f, 4.362f)
            close()
            moveTo(4.532f, 3.015f)
            curveTo(4.532f, 3.079f, 4.48f, 3.131f, 4.416f, 3.131f)
            curveTo(4.351f, 3.131f, 4.299f, 3.079f, 4.299f, 3.015f)
            curveTo(4.299f, 2.952f, 4.351f, 2.9f, 4.416f, 2.9f)
            curveTo(4.48f, 2.9f, 4.532f, 2.952f, 4.532f, 3.015f)
            close()
            moveTo(2.584f, 3.823f)
            curveTo(2.649f, 3.823f, 2.701f, 3.771f, 2.701f, 3.708f)
            curveTo(2.701f, 3.644f, 2.649f, 3.592f, 2.584f, 3.592f)
            curveTo(2.52f, 3.592f, 2.468f, 3.644f, 2.468f, 3.708f)
            curveTo(2.468f, 3.771f, 2.52f, 3.823f, 2.584f, 3.823f)
            close()
            moveTo(4.532f, 3.708f)
            curveTo(4.532f, 3.771f, 4.48f, 3.823f, 4.416f, 3.823f)
            curveTo(4.351f, 3.823f, 4.299f, 3.771f, 4.299f, 3.708f)
            curveTo(4.299f, 3.644f, 4.351f, 3.592f, 4.416f, 3.592f)
            curveTo(4.48f, 3.592f, 4.532f, 3.644f, 4.532f, 3.708f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.803f, 3.196f)
            lineTo(3.183f, 2.853f)
            horizontalLineTo(3.798f)
            lineTo(4.231f, 3.246f)
            horizontalLineTo(4.805f)
            verticalLineTo(3.4f)
            horizontalLineTo(4.246f)
            verticalLineTo(3.408f)
            lineTo(3.798f, 3.864f)
            horizontalLineTo(3.183f)
            lineTo(2.803f, 3.452f)
            verticalLineTo(3.4f)
            horizontalLineTo(2.156f)
            verticalLineTo(3.246f)
            horizontalLineTo(2.803f)
            verticalLineTo(3.196f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.505f, 3.138f)
            lineTo(3.69f, 3.325f)
            lineTo(3.496f, 3.508f)
            lineTo(3.303f, 3.325f)
            lineTo(3.487f, 3.138f)
            lineTo(3.496f, 3.13f)
            lineTo(3.505f, 3.138f)
            close()
            moveTo(3.539f, 3.589f)
            lineTo(3.561f, 3.569f)
            lineTo(3.538f, 3.548f)
            lineTo(3.73f, 3.366f)
            lineTo(3.931f, 3.569f)
            lineTo(3.841f, 3.664f)
            horizontalLineTo(3.787f)
            lineTo(3.688f, 3.727f)
            lineTo(3.539f, 3.589f)
            close()
            moveTo(3.496f, 3.628f)
            lineTo(3.312f, 3.799f)
            lineTo(3.188f, 3.722f)
            horizontalLineTo(3.127f)
            lineTo(2.981f, 3.568f)
            lineTo(3.22f, 3.326f)
            lineTo(2.98f, 3.099f)
            lineTo(3.137f, 2.946f)
            lineTo(3.194f, 2.99f)
            lineTo(3.277f, 2.907f)
            lineTo(3.252f, 2.882f)
            lineTo(3.294f, 2.841f)
            lineTo(3.496f, 3.046f)
            lineTo(3.698f, 2.841f)
            lineTo(3.74f, 2.882f)
            lineTo(3.715f, 2.907f)
            lineTo(3.798f, 2.99f)
            lineTo(3.855f, 2.946f)
            lineTo(4.013f, 3.099f)
            lineTo(3.773f, 3.326f)
            lineTo(4.011f, 3.568f)
            lineTo(3.866f, 3.722f)
            horizontalLineTo(3.804f)
            lineTo(3.681f, 3.799f)
            lineTo(3.496f, 3.628f)
            close()
            moveTo(3.599f, 3.151f)
            lineTo(3.602f, 3.148f)
            lineTo(3.546f, 3.097f)
            lineTo(3.539f, 3.09f)
            lineTo(3.683f, 2.957f)
            lineTo(3.793f, 3.068f)
            lineTo(3.851f, 3.023f)
            lineTo(3.929f, 3.098f)
            lineTo(3.732f, 3.285f)
            lineTo(3.599f, 3.151f)
            close()
            moveTo(3.476f, 3.569f)
            lineTo(3.305f, 3.727f)
            lineTo(3.205f, 3.664f)
            horizontalLineTo(3.152f)
            lineTo(3.062f, 3.569f)
            lineTo(3.262f, 3.366f)
            lineTo(3.476f, 3.569f)
            close()
            moveTo(3.063f, 3.098f)
            lineTo(3.261f, 3.285f)
            lineTo(3.453f, 3.09f)
            lineTo(3.309f, 2.957f)
            lineTo(3.199f, 3.068f)
            lineTo(3.141f, 3.023f)
            lineTo(3.063f, 3.098f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.224f, 10.721f)
            curveTo(2.12f, 10.588f, 2.049f, 10.499f, 2.031f, 10.5f)
            curveTo(1.972f, 10.504f, 1.918f, 11.122f, 2.676f, 11.592f)
            curveTo(2.676f, 11.592f, 2.788f, 11.654f, 2.853f, 11.592f)
            curveTo(2.918f, 11.53f, 2.853f, 11.438f, 2.853f, 11.438f)
            curveTo(2.608f, 11.208f, 2.379f, 10.917f, 2.224f, 10.721f)
            lineTo(2.224f, 10.721f)
            close()
            moveTo(4.776f, 10.721f)
            lineTo(4.776f, 10.721f)
            lineTo(4.776f, 10.721f)
            curveTo(4.88f, 10.588f, 4.951f, 10.499f, 4.969f, 10.5f)
            curveTo(5.028f, 10.504f, 5.082f, 11.122f, 4.324f, 11.592f)
            curveTo(4.324f, 11.592f, 4.212f, 11.654f, 4.147f, 11.592f)
            curveTo(4.082f, 11.53f, 4.147f, 11.438f, 4.147f, 11.438f)
            curveTo(4.392f, 11.208f, 4.621f, 10.917f, 4.776f, 10.721f)
            close()
            moveTo(4.72f, 11.552f)
            curveTo(4.471f, 11.625f, 4.183f, 11.641f, 4.072f, 11.593f)
            curveTo(4.037f, 11.578f, 4f, 11.566f, 3.96f, 11.557f)
            curveTo(3.851f, 11.532f, 3.744f, 11.532f, 3.617f, 11.546f)
            lineTo(3.567f, 11.552f)
            curveTo(3.555f, 11.553f, 3.548f, 11.554f, 3.546f, 11.554f)
            curveTo(3.539f, 11.554f, 3.531f, 11.555f, 3.522f, 11.557f)
            curveTo(3.513f, 11.555f, 3.505f, 11.554f, 3.497f, 11.554f)
            curveTo(3.496f, 11.554f, 3.489f, 11.553f, 3.477f, 11.552f)
            lineTo(3.427f, 11.546f)
            curveTo(3.3f, 11.532f, 3.193f, 11.532f, 3.083f, 11.557f)
            curveTo(3.044f, 11.566f, 3.007f, 11.578f, 2.972f, 11.593f)
            curveTo(2.861f, 11.641f, 2.573f, 11.625f, 2.323f, 11.552f)
            curveTo(2.323f, 11.552f, 2.777f, 11.734f, 3.046f, 11.653f)
            curveTo(3.072f, 11.642f, 3.1f, 11.633f, 3.129f, 11.627f)
            curveTo(3.205f, 11.609f, 3.284f, 11.608f, 3.378f, 11.616f)
            curveTo(3.339f, 11.635f, 3.292f, 11.656f, 3.239f, 11.678f)
            verticalLineTo(11.7f)
            curveTo(3.345f, 11.657f, 3.469f, 11.637f, 3.522f, 11.63f)
            curveTo(3.575f, 11.637f, 3.699f, 11.657f, 3.805f, 11.7f)
            verticalLineTo(11.678f)
            curveTo(3.751f, 11.656f, 3.705f, 11.635f, 3.665f, 11.616f)
            curveTo(3.76f, 11.608f, 3.838f, 11.609f, 3.915f, 11.627f)
            curveTo(3.944f, 11.633f, 3.972f, 11.642f, 3.998f, 11.653f)
            curveTo(4.267f, 11.734f, 4.72f, 11.552f, 4.72f, 11.552f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF389F5D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.882f, 4.989f)
            lineTo(2.256f, 5.54f)
            verticalLineTo(6.066f)
            lineTo(2.803f, 6.616f)
            horizontalLineTo(3.921f)
            lineTo(4.537f, 6.029f)
            verticalLineTo(5.582f)
            lineTo(3.921f, 4.989f)
            horizontalLineTo(2.882f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.097f, 5.047f)
            horizontalLineTo(2.956f)
            verticalLineTo(5.156f)
            horizontalLineTo(3.097f)
            verticalLineTo(5.047f)
            close()
            moveTo(3.097f, 6.477f)
            horizontalLineTo(2.956f)
            verticalLineTo(6.587f)
            horizontalLineTo(3.097f)
            verticalLineTo(6.477f)
            close()
            moveTo(3.31f, 6.477f)
            horizontalLineTo(3.451f)
            verticalLineTo(6.587f)
            horizontalLineTo(3.31f)
            verticalLineTo(6.477f)
            close()
            moveTo(3.451f, 5.047f)
            horizontalLineTo(3.31f)
            verticalLineTo(5.156f)
            horizontalLineTo(3.451f)
            verticalLineTo(5.047f)
            close()
            moveTo(3.664f, 6.477f)
            horizontalLineTo(3.805f)
            verticalLineTo(6.587f)
            horizontalLineTo(3.664f)
            verticalLineTo(6.477f)
            close()
            moveTo(3.805f, 5.047f)
            horizontalLineTo(3.664f)
            verticalLineTo(5.156f)
            horizontalLineTo(3.805f)
            verticalLineTo(5.047f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.277f, 5.019f)
            horizontalLineTo(3.133f)
            verticalLineTo(5.128f)
            horizontalLineTo(3.277f)
            verticalLineTo(5.019f)
            close()
            moveTo(3.277f, 6.477f)
            horizontalLineTo(3.133f)
            verticalLineTo(6.587f)
            horizontalLineTo(3.277f)
            verticalLineTo(6.477f)
            close()
            moveTo(3.493f, 5.019f)
            horizontalLineTo(3.637f)
            verticalLineTo(5.128f)
            horizontalLineTo(3.493f)
            verticalLineTo(5.019f)
            close()
            moveTo(3.637f, 6.477f)
            horizontalLineTo(3.493f)
            verticalLineTo(6.587f)
            horizontalLineTo(3.637f)
            verticalLineTo(6.477f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF750100)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.457f, 4.921f)
            horizontalLineTo(4.347f)
            verticalLineTo(5.213f)
            horizontalLineTo(4.617f)
            verticalLineTo(6.42f)
            horizontalLineTo(4.347f)
            verticalLineTo(6.67f)
            horizontalLineTo(2.457f)
            verticalLineTo(6.42f)
            horizontalLineTo(2.163f)
            verticalLineTo(5.213f)
            horizontalLineTo(2.457f)
            verticalLineTo(4.921f)
            close()
            moveTo(2.563f, 5.322f)
            horizontalLineTo(2.269f)
            verticalLineTo(6.311f)
            horizontalLineTo(2.563f)
            verticalLineTo(6.561f)
            horizontalLineTo(4.241f)
            verticalLineTo(6.311f)
            horizontalLineTo(4.511f)
            verticalLineTo(5.322f)
            horizontalLineTo(4.241f)
            verticalLineTo(5.03f)
            horizontalLineTo(2.563f)
            verticalLineTo(5.322f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF389F5D)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.204f, 4.8f)
            horizontalLineTo(3.027f)
            verticalLineTo(4.982f)
            horizontalLineTo(3.204f)
            verticalLineTo(4.8f)
            close()
            moveTo(3.487f, 4.8f)
            horizontalLineTo(3.31f)
            verticalLineTo(4.982f)
            horizontalLineTo(3.487f)
            verticalLineTo(4.8f)
            close()
            moveTo(3.593f, 4.8f)
            horizontalLineTo(3.77f)
            verticalLineTo(4.982f)
            horizontalLineTo(3.593f)
            verticalLineTo(4.8f)
            close()
            moveTo(3.204f, 6.623f)
            horizontalLineTo(3.027f)
            verticalLineTo(6.805f)
            horizontalLineTo(3.204f)
            verticalLineTo(6.623f)
            close()
            moveTo(3.31f, 6.623f)
            horizontalLineTo(3.487f)
            verticalLineTo(6.805f)
            horizontalLineTo(3.31f)
            verticalLineTo(6.623f)
            close()
            moveTo(3.77f, 6.623f)
            horizontalLineTo(3.593f)
            verticalLineTo(6.805f)
            horizontalLineTo(3.77f)
            verticalLineTo(6.623f)
            close()
            moveTo(1.997f, 6.219f)
            verticalLineTo(6.042f)
            horizontalLineTo(2.18f)
            verticalLineTo(6.219f)
            horizontalLineTo(1.997f)
            close()
            moveTo(1.997f, 5.751f)
            verticalLineTo(5.928f)
            horizontalLineTo(2.18f)
            verticalLineTo(5.751f)
            horizontalLineTo(1.997f)
            close()
            moveTo(1.997f, 5.636f)
            verticalLineTo(5.459f)
            horizontalLineTo(2.18f)
            verticalLineTo(5.636f)
            horizontalLineTo(1.997f)
            close()
            moveTo(4.546f, 6.042f)
            verticalLineTo(6.219f)
            horizontalLineTo(4.728f)
            verticalLineTo(6.042f)
            horizontalLineTo(4.546f)
            close()
            moveTo(4.546f, 5.928f)
            verticalLineTo(5.751f)
            horizontalLineTo(4.728f)
            verticalLineTo(5.928f)
            horizontalLineTo(4.546f)
            close()
            moveTo(4.546f, 5.459f)
            verticalLineTo(5.636f)
            horizontalLineTo(4.728f)
            verticalLineTo(5.459f)
            horizontalLineTo(4.546f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.889f, 5.142f)
            lineTo(2.584f, 5.408f)
            verticalLineTo(6.267f)
            lineTo(2.837f, 6.446f)
            horizontalLineTo(3.936f)
            lineTo(4.188f, 6.267f)
            verticalLineTo(5.408f)
            lineTo(3.903f, 5.142f)
            horizontalLineTo(2.889f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE1E5E8)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.402f, 5.498f)
            lineTo(3.033f, 5.813f)
            horizontalLineTo(3.402f)
            verticalLineTo(5.498f)
            close()
        }
        path(fill = SolidColor(Color(0xFFE8AA00))) {
            moveTo(3.402f, 6.099f)
            lineTo(3.033f, 5.784f)
            horizontalLineTo(3.402f)
            verticalLineTo(6.099f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.37f, 5.498f)
            lineTo(3.738f, 5.813f)
            horizontalLineTo(3.37f)
            verticalLineTo(5.498f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF29AE66)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.386f, 5.898f)
            curveTo(3.447f, 5.898f, 3.497f, 5.848f, 3.497f, 5.787f)
            curveTo(3.497f, 5.725f, 3.447f, 5.675f, 3.386f, 5.675f)
            curveTo(3.324f, 5.675f, 3.274f, 5.725f, 3.274f, 5.787f)
            curveTo(3.274f, 5.848f, 3.324f, 5.898f, 3.386f, 5.898f)
            close()
        }
        path(fill = SolidColor(Color(0xFFE1E5E8))) {
            moveTo(3.37f, 6.099f)
            lineTo(3.738f, 5.784f)
            horizontalLineTo(3.37f)
            verticalLineTo(6.099f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.602f, 5.675f)
            horizontalLineTo(2.283f)
            verticalLineTo(5.777f)
            horizontalLineTo(2.602f)
            verticalLineTo(5.675f)
            close()
            moveTo(2.602f, 5.861f)
            horizontalLineTo(2.283f)
            verticalLineTo(5.963f)
            horizontalLineTo(2.602f)
            verticalLineTo(5.861f)
            close()
            moveTo(4.195f, 5.675f)
            horizontalLineTo(4.513f)
            verticalLineTo(5.777f)
            horizontalLineTo(4.195f)
            verticalLineTo(5.675f)
            close()
            moveTo(4.513f, 5.861f)
            horizontalLineTo(4.195f)
            verticalLineTo(5.963f)
            horizontalLineTo(4.513f)
            verticalLineTo(5.861f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.566f, 5.566f)
            horizontalLineTo(2.283f)
            verticalLineTo(5.677f)
            horizontalLineTo(2.566f)
            verticalLineTo(5.566f)
            close()
            moveTo(2.566f, 5.752f)
            horizontalLineTo(2.283f)
            verticalLineTo(5.863f)
            horizontalLineTo(2.566f)
            verticalLineTo(5.752f)
            close()
            moveTo(2.283f, 5.938f)
            horizontalLineTo(2.566f)
            verticalLineTo(6.049f)
            horizontalLineTo(2.283f)
            verticalLineTo(5.938f)
            close()
            moveTo(4.478f, 5.566f)
            horizontalLineTo(4.195f)
            verticalLineTo(5.677f)
            horizontalLineTo(4.478f)
            verticalLineTo(5.566f)
            close()
            moveTo(4.195f, 5.752f)
            horizontalLineTo(4.478f)
            verticalLineTo(5.863f)
            horizontalLineTo(4.195f)
            verticalLineTo(5.752f)
            close()
            moveTo(4.478f, 5.938f)
            horizontalLineTo(4.195f)
            verticalLineTo(6.049f)
            horizontalLineTo(4.478f)
            verticalLineTo(5.938f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE8AA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.993f, 0.795f)
            lineTo(4.991f, 0.998f)
            horizontalLineTo(3.512f)
            lineTo(3.511f, 1.918f)
            horizontalLineTo(3.047f)
            curveTo(2.966f, 1.918f, 2.744f, 1.762f, 2.744f, 1.762f)
            horizontalLineTo(2.367f)
            lineTo(2.193f, 1.585f)
            verticalLineTo(1.406f)
            lineTo(2.007f, 1.185f)
            lineTo(2.008f, 0.982f)
            horizontalLineTo(3.487f)
            lineTo(3.488f, 0.062f)
            horizontalLineTo(3.952f)
            curveTo(4.033f, 0.062f, 4.255f, 0.217f, 4.255f, 0.217f)
            horizontalLineTo(4.632f)
            lineTo(4.806f, 0.395f)
            verticalLineTo(0.574f)
            lineTo(4.993f, 0.795f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFE1E5E8)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.007f, 0.795f)
            lineTo(2.008f, 0.998f)
            horizontalLineTo(3.487f)
            lineTo(3.488f, 1.918f)
            horizontalLineTo(3.952f)
            curveTo(4.033f, 1.918f, 4.255f, 1.762f, 4.255f, 1.762f)
            horizontalLineTo(4.632f)
            lineTo(4.806f, 1.585f)
            verticalLineTo(1.406f)
            lineTo(4.993f, 1.185f)
            lineTo(4.991f, 0.982f)
            horizontalLineTo(3.512f)
            lineTo(3.511f, 0.062f)
            horizontalLineTo(3.047f)
            curveTo(2.966f, 0.062f, 2.744f, 0.217f, 2.744f, 0.217f)
            horizontalLineTo(2.367f)
            lineTo(2.193f, 0.395f)
            verticalLineTo(0.574f)
            lineTo(2.007f, 0.795f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.001f, 0.343f)
            lineTo(2.985f, 0.264f)
            lineTo(3.304f, 0.191f)
            curveTo(3.342f, 0.173f, 3.409f, 0.12f, 3.5f, 0.034f)
            lineTo(3.543f, 0.083f)
            lineTo(3.551f, 0.074f)
            curveTo(3.642f, 0.16f, 3.709f, 0.213f, 3.747f, 0.231f)
            lineTo(4.066f, 0.304f)
            lineTo(4.05f, 0.383f)
            lineTo(3.873f, 0.346f)
            lineTo(3.89f, 0.361f)
            curveTo(3.878f, 0.369f, 3.865f, 0.379f, 3.85f, 0.393f)
            lineTo(3.776f, 0.382f)
            lineTo(3.783f, 0.357f)
            lineTo(3.764f, 0.354f)
            curveTo(3.75f, 0.38f, 3.734f, 0.417f, 3.718f, 0.464f)
            lineTo(3.643f, 0.442f)
            lineTo(3.673f, 0.297f)
            lineTo(3.504f, 0.139f)
            lineTo(3.386f, 0.25f)
            curveTo(3.401f, 0.263f, 3.415f, 0.279f, 3.43f, 0.296f)
            curveTo(3.418f, 0.301f, 3.406f, 0.305f, 3.394f, 0.309f)
            lineTo(3.389f, 0.31f)
            lineTo(3.408f, 0.402f)
            lineTo(3.334f, 0.424f)
            curveTo(3.324f, 0.397f, 3.314f, 0.373f, 3.306f, 0.352f)
            lineTo(3.299f, 0.353f)
            curveTo(3.285f, 0.339f, 3.272f, 0.329f, 3.26f, 0.321f)
            lineTo(3.281f, 0.302f)
            curveTo(3.278f, 0.296f, 3.274f, 0.291f, 3.271f, 0.287f)
            lineTo(3.001f, 0.343f)
            close()
            moveTo(3.014f, 0.629f)
            lineTo(3.057f, 0.562f)
            lineTo(2.837f, 0.414f)
            lineTo(2.861f, 0.38f)
            lineTo(2.798f, 0.333f)
            lineTo(2.771f, 0.371f)
            lineTo(2.684f, 0.312f)
            lineTo(2.641f, 0.379f)
            lineTo(2.725f, 0.435f)
            lineTo(2.708f, 0.459f)
            lineTo(2.771f, 0.507f)
            lineTo(2.79f, 0.479f)
            lineTo(3.014f, 0.629f)
            close()
            moveTo(2.742f, 0.709f)
            lineTo(2.784f, 0.642f)
            lineTo(2.564f, 0.494f)
            lineTo(2.588f, 0.46f)
            lineTo(2.525f, 0.413f)
            lineTo(2.498f, 0.451f)
            lineTo(2.411f, 0.392f)
            lineTo(2.368f, 0.459f)
            lineTo(2.452f, 0.515f)
            lineTo(2.435f, 0.539f)
            lineTo(2.498f, 0.587f)
            lineTo(2.518f, 0.559f)
            lineTo(2.742f, 0.709f)
            close()
            moveTo(2.625f, 0.949f)
            lineTo(2.667f, 0.882f)
            lineTo(2.447f, 0.734f)
            lineTo(2.471f, 0.7f)
            lineTo(2.409f, 0.653f)
            lineTo(2.382f, 0.691f)
            lineTo(2.294f, 0.632f)
            lineTo(2.251f, 0.699f)
            lineTo(2.335f, 0.755f)
            lineTo(2.318f, 0.779f)
            lineTo(2.381f, 0.827f)
            lineTo(2.401f, 0.799f)
            lineTo(2.625f, 0.949f)
            close()
            moveTo(2.628f, 1.141f)
            lineTo(2.586f, 1.074f)
            lineTo(2.362f, 1.224f)
            lineTo(2.342f, 1.197f)
            lineTo(2.279f, 1.244f)
            lineTo(2.296f, 1.268f)
            lineTo(2.213f, 1.324f)
            lineTo(2.255f, 1.391f)
            lineTo(2.343f, 1.333f)
            lineTo(2.37f, 1.371f)
            lineTo(2.432f, 1.323f)
            lineTo(2.408f, 1.289f)
            lineTo(2.628f, 1.141f)
            close()
            moveTo(2.703f, 1.314f)
            lineTo(2.745f, 1.381f)
            lineTo(2.525f, 1.529f)
            lineTo(2.549f, 1.563f)
            lineTo(2.487f, 1.611f)
            lineTo(2.459f, 1.573f)
            lineTo(2.372f, 1.631f)
            lineTo(2.329f, 1.564f)
            lineTo(2.413f, 1.508f)
            lineTo(2.396f, 1.484f)
            lineTo(2.459f, 1.437f)
            lineTo(2.479f, 1.464f)
            lineTo(2.703f, 1.314f)
            close()
            moveTo(2.975f, 1.394f)
            lineTo(3.018f, 1.461f)
            lineTo(2.798f, 1.609f)
            lineTo(2.822f, 1.643f)
            lineTo(2.759f, 1.691f)
            lineTo(2.732f, 1.653f)
            lineTo(2.645f, 1.711f)
            lineTo(2.602f, 1.644f)
            lineTo(2.686f, 1.588f)
            lineTo(2.669f, 1.564f)
            lineTo(2.732f, 1.517f)
            lineTo(2.751f, 1.544f)
            lineTo(2.975f, 1.394f)
            close()
            moveTo(3.391f, 1.777f)
            curveTo(3.379f, 1.772f, 3.367f, 1.768f, 3.355f, 1.764f)
            lineTo(3.34f, 1.76f)
            lineTo(3.369f, 1.621f)
            lineTo(3.295f, 1.599f)
            curveTo(3.271f, 1.667f, 3.249f, 1.713f, 3.232f, 1.736f)
            lineTo(2.962f, 1.681f)
            lineTo(2.946f, 1.759f)
            lineTo(3.254f, 1.83f)
            lineTo(3.254f, 1.83f)
            lineTo(3.298f, 1.86f)
            lineTo(3.304f, 1.856f)
            curveTo(3.343f, 1.883f, 3.396f, 1.928f, 3.462f, 1.989f)
            lineTo(3.487f, 1.961f)
            lineTo(3.512f, 1.989f)
            curveTo(3.603f, 1.904f, 3.67f, 1.851f, 3.708f, 1.832f)
            lineTo(3.719f, 1.83f)
            curveTo(3.732f, 1.841f, 3.745f, 1.851f, 3.759f, 1.86f)
            lineTo(3.804f, 1.83f)
            lineTo(3.799f, 1.815f)
            lineTo(3.804f, 1.81f)
            lineTo(4.027f, 1.759f)
            lineTo(4.011f, 1.681f)
            lineTo(3.741f, 1.736f)
            curveTo(3.724f, 1.713f, 3.703f, 1.667f, 3.679f, 1.599f)
            lineTo(3.604f, 1.621f)
            lineTo(3.634f, 1.766f)
            lineTo(3.487f, 1.904f)
            lineTo(3.373f, 1.797f)
            curveTo(3.379f, 1.791f, 3.385f, 1.784f, 3.391f, 1.777f)
            close()
            moveTo(4.345f, 1.141f)
            lineTo(4.388f, 1.074f)
            lineTo(4.612f, 1.224f)
            lineTo(4.631f, 1.197f)
            lineTo(4.694f, 1.244f)
            lineTo(4.677f, 1.268f)
            lineTo(4.761f, 1.324f)
            lineTo(4.718f, 1.391f)
            lineTo(4.631f, 1.333f)
            lineTo(4.604f, 1.371f)
            lineTo(4.541f, 1.323f)
            lineTo(4.565f, 1.289f)
            lineTo(4.345f, 1.141f)
            close()
            moveTo(4.228f, 1.381f)
            lineTo(4.271f, 1.314f)
            lineTo(4.495f, 1.464f)
            lineTo(4.514f, 1.437f)
            lineTo(4.577f, 1.484f)
            lineTo(4.56f, 1.508f)
            lineTo(4.644f, 1.564f)
            lineTo(4.601f, 1.631f)
            lineTo(4.514f, 1.573f)
            lineTo(4.487f, 1.611f)
            lineTo(4.424f, 1.563f)
            lineTo(4.448f, 1.529f)
            lineTo(4.228f, 1.381f)
            close()
            moveTo(3.955f, 1.461f)
            lineTo(3.998f, 1.394f)
            lineTo(4.222f, 1.544f)
            lineTo(4.242f, 1.517f)
            lineTo(4.305f, 1.564f)
            lineTo(4.287f, 1.588f)
            lineTo(4.371f, 1.644f)
            lineTo(4.329f, 1.711f)
            lineTo(4.241f, 1.653f)
            lineTo(4.214f, 1.691f)
            lineTo(4.151f, 1.643f)
            lineTo(4.176f, 1.609f)
            lineTo(3.955f, 1.461f)
            close()
            moveTo(4.384f, 0.922f)
            lineTo(4.427f, 0.989f)
            lineTo(4.651f, 0.839f)
            lineTo(4.67f, 0.867f)
            lineTo(4.733f, 0.819f)
            lineTo(4.716f, 0.795f)
            lineTo(4.8f, 0.739f)
            lineTo(4.757f, 0.672f)
            lineTo(4.67f, 0.731f)
            lineTo(4.643f, 0.693f)
            lineTo(4.58f, 0.74f)
            lineTo(4.604f, 0.774f)
            lineTo(4.384f, 0.922f)
            close()
            moveTo(4.267f, 0.682f)
            lineTo(4.31f, 0.749f)
            lineTo(4.534f, 0.599f)
            lineTo(4.553f, 0.627f)
            lineTo(4.616f, 0.579f)
            lineTo(4.599f, 0.555f)
            lineTo(4.683f, 0.499f)
            lineTo(4.64f, 0.432f)
            lineTo(4.553f, 0.491f)
            lineTo(4.526f, 0.453f)
            lineTo(4.463f, 0.5f)
            lineTo(4.487f, 0.534f)
            lineTo(4.267f, 0.682f)
            close()
            moveTo(3.994f, 0.602f)
            lineTo(4.037f, 0.669f)
            lineTo(4.261f, 0.519f)
            lineTo(4.281f, 0.547f)
            lineTo(4.344f, 0.499f)
            lineTo(4.326f, 0.475f)
            lineTo(4.41f, 0.419f)
            lineTo(4.368f, 0.352f)
            lineTo(4.28f, 0.411f)
            lineTo(4.253f, 0.373f)
            lineTo(4.19f, 0.42f)
            lineTo(4.215f, 0.454f)
            lineTo(3.994f, 0.602f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.104f, 0.577f)
            lineTo(3.545f, 0.343f)
            verticalLineTo(0.983f)
            horizontalLineTo(4.636f)
            lineTo(4.376f, 1.17f)
            verticalLineTo(1.415f)
            horizontalLineTo(3.965f)
            lineTo(3.523f, 1.649f)
            verticalLineTo(1.009f)
            horizontalLineTo(2.432f)
            lineTo(2.692f, 0.821f)
            verticalLineTo(0.577f)
            horizontalLineTo(3.104f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF29AE66)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.965f, 0.577f)
            lineTo(3.523f, 0.343f)
            verticalLineTo(0.983f)
            horizontalLineTo(2.432f)
            lineTo(2.692f, 1.17f)
            verticalLineTo(1.415f)
            horizontalLineTo(3.104f)
            lineTo(3.545f, 1.649f)
            verticalLineTo(1.009f)
            horizontalLineTo(4.636f)
            lineTo(4.376f, 0.821f)
            verticalLineTo(0.577f)
            horizontalLineTo(3.965f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF29AE66)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(2.89f, 0.742f)
            lineTo(2.962f, 0.6f)
            lineTo(3.145f, 0.698f)
            lineTo(3.195f, 0.623f)
            lineTo(3.323f, 0.714f)
            lineTo(3.284f, 0.773f)
            lineTo(3.826f, 1.063f)
            lineTo(3.86f, 1.013f)
            lineTo(3.988f, 1.104f)
            lineTo(3.965f, 1.137f)
            lineTo(4.024f, 1.169f)
            lineTo(3.952f, 1.311f)
            lineTo(3.876f, 1.27f)
            lineTo(3.815f, 1.362f)
            lineTo(3.686f, 1.271f)
            lineTo(3.737f, 1.196f)
            lineTo(3.195f, 0.906f)
            lineTo(3.15f, 0.972f)
            lineTo(3.022f, 0.881f)
            lineTo(3.056f, 0.831f)
            lineTo(2.89f, 0.742f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFC51918)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(4.045f, 0.703f)
            lineTo(3.963f, 0.567f)
            lineTo(3.787f, 0.677f)
            lineTo(3.732f, 0.606f)
            lineTo(3.61f, 0.706f)
            lineTo(3.653f, 0.761f)
            lineTo(3.133f, 1.088f)
            lineTo(3.096f, 1.041f)
            lineTo(2.974f, 1.141f)
            lineTo(2.999f, 1.173f)
            lineTo(2.943f, 1.208f)
            lineTo(3.025f, 1.344f)
            lineTo(3.097f, 1.299f)
            lineTo(3.165f, 1.386f)
            lineTo(3.287f, 1.286f)
            lineTo(3.231f, 1.215f)
            lineTo(3.752f, 0.888f)
            lineTo(3.801f, 0.95f)
            lineTo(3.922f, 0.851f)
            lineTo(3.885f, 0.804f)
            lineTo(4.045f, 0.703f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFF7FCFF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(9.537f, 1f)
            curveTo(9.537f, 1f, 10.702f, 3.761f, 9.667f, 4.933f)
            curveTo(8.632f, 6.106f, 6f, 5.88f, 6f, 5.88f)
            curveTo(6f, 5.88f, 9.378f, 7.405f, 10.85f, 5.305f)
            curveTo(12.322f, 3.204f, 9.537f, 1f, 9.537f, 1f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFF7FCFF)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(7.422f, 2.624f)
            lineTo(7.114f, 2.841f)
            lineTo(7.223f, 2.478f)
            lineTo(6.923f, 2.248f)
            lineTo(7.299f, 2.24f)
            lineTo(7.422f, 1.882f)
            lineTo(7.545f, 2.24f)
            lineTo(7.921f, 2.248f)
            lineTo(7.622f, 2.478f)
            lineTo(7.73f, 2.841f)
            lineTo(7.422f, 2.624f)
            close()
            moveTo(7.482f, 3.627f)
            lineTo(7.173f, 3.844f)
            lineTo(7.282f, 3.48f)
            lineTo(6.983f, 3.251f)
            lineTo(7.358f, 3.243f)
            lineTo(7.482f, 2.884f)
            lineTo(7.605f, 3.243f)
            lineTo(7.981f, 3.251f)
            lineTo(7.681f, 3.48f)
            lineTo(7.79f, 3.844f)
            lineTo(7.482f, 3.627f)
            close()
            moveTo(6.236f, 3.921f)
            lineTo(6.545f, 3.704f)
            lineTo(6.853f, 3.921f)
            lineTo(6.744f, 3.558f)
            lineTo(7.043f, 3.328f)
            lineTo(6.668f, 3.32f)
            lineTo(6.545f, 2.962f)
            lineTo(6.421f, 3.32f)
            lineTo(6.046f, 3.328f)
            lineTo(6.345f, 3.558f)
            lineTo(6.236f, 3.921f)
            close()
            moveTo(7.482f, 4.679f)
            lineTo(7.173f, 4.896f)
            lineTo(7.282f, 4.532f)
            lineTo(6.983f, 4.302f)
            lineTo(7.358f, 4.295f)
            lineTo(7.482f, 3.936f)
            lineTo(7.605f, 4.295f)
            lineTo(7.981f, 4.302f)
            lineTo(7.681f, 4.532f)
            lineTo(7.79f, 4.896f)
            lineTo(7.482f, 4.679f)
            close()
            moveTo(8.192f, 3.537f)
            lineTo(8.501f, 3.32f)
            lineTo(8.809f, 3.537f)
            lineTo(8.7f, 3.174f)
            lineTo(8.999f, 2.944f)
            lineTo(8.624f, 2.937f)
            lineTo(8.501f, 2.578f)
            lineTo(8.377f, 2.937f)
            lineTo(8.002f, 2.944f)
            lineTo(8.301f, 3.174f)
            lineTo(8.192f, 3.537f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun TurkmenistanPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Turkmenistan,
            contentDescription = "Turkmenistan Flag"
        )
    }
}
